import React, { useContext } from 'react';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { AppContext, IAppContext } from 'appState/appContext';
import { IDishesContext, DishesContext } from '../../../../dishesState/dishesContext';
import {
	ICopyMenuModalContext,
	CopyMenuModalContext,
} from '../copyMenuModalContext/copyMenuModalState/copyMenuModalContext';
import { copyMenu } from 'backend/restaurants';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, IDSelectedRestaurant } = useContext<IDishesContext>(DishesContext);
	const {
		changeTypeOfCopyMenuModalWindow,
		setIDsRestaurantsToCopyMenu,
		IDsSelectedRestaurantsToCopyMenu,
		typeOfCopyMenuModalWindow,
	} = useContext<ICopyMenuModalContext>(CopyMenuModalContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfCopyMenuModalWindow });

	const handleConfirm = async () => {
		if (IDSelectedRestaurant) {
			try {
				const dataForCopyMenu = {
					fromRestaurantId: IDSelectedRestaurant,
					toRestaurantIds: IDsSelectedRestaurantsToCopyMenu,
				};
				showLoader();
				await copyMenu(dataForCopyMenu);
				changeTypeOfCopyMenuModalWindow('success');
				setIDsRestaurantsToCopyMenu([]);
			} catch (err) {
				changeTypeOfCopyMenuModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	};

	const handleCloseAllModals = () => {
		changeTypeOfModalWindow(null);
		changeTypeOfCopyMenuModalWindow(null);
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={handleConfirm}
				onFailureEvent={() => changeTypeOfCopyMenuModalWindow(null)}
				isVisible={typeOfCopyMenuModalWindow === 'toConfirmCopyMenu'}
				description="sureToCopyMenu"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleCloseAllModals}
				isVisible={typeOfCopyMenuModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfCopyMenuModalWindow(null)}
				isVisible={typeOfCopyMenuModalWindow === 'error'}
				description="errorWhileCopyingMenu"
			/>
		</div>
	);
};

export default ModalWindows;
